import { Td } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useGetPortalMyBidsQuery } from "../../../../autogen/bff-api";
import { momentLocaleFor } from "../../../../common/formatting/i18nFormatters";
import { urls } from "../../../../urls";
import { PortalLifecycleTag } from "../../../sourcing-events/portal/components/PortalLifecycleTag";
import { BidV2StatusTag } from "../../sourcing-event/BidV2StatusTag";
import { myBidDeadlineText, myBidTagProps, sortByUrgency } from "../../supplier/myBids";
import { HomePanel } from "./HomePanel";
import { MutedCell, PanelRow, PanelTable, TitleCell } from "./PanelTable";

const DISPLAY_LIMIT = 6;

export const MyBidsPanel = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const locale = momentLocaleFor(i18n.language);

  const { data, isLoading, isError } = useGetPortalMyBidsQuery({});
  const bids = sortByUrgency(data?.bids ?? []).slice(0, DISPLAY_LIMIT);

  return (
    <HomePanel titleKey="My bids" seeAllTo={urls.v2.supplier.bids} isLoading={isLoading} isError={isError} isEmpty={bids.length === 0} emptyKey="No offers yet">
      <PanelTable headers={[t("Title"), t("Competition"), t("My bid"), t("Deadline")]}>
        {bids.map((bid) => (
          <PanelRow key={bid.event.id} onClick={() => navigate(urls.v2.supplier.procurement.go(bid.eventId))}>
            <TitleCell title={bid.event.title || t("Untitled")} />
            <Td>
              <PortalLifecycleTag status={bid.event.lifecycle.status} stage={bid.event.competitionStage} />
            </Td>
            <Td>
              <BidV2StatusTag {...myBidTagProps(bid)} size="sm" />
            </Td>
            <MutedCell>{myBidDeadlineText(bid, locale)}</MutedCell>
          </PanelRow>
        ))}
      </PanelTable>
    </HomePanel>
  );
};
